import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PagePictureData {
  pageId: string;
  pageName: string;
  pictureUrl: string | null;
  isSilhouette: boolean;
}

export function useCachedPagePicture(
  pageId: string | undefined,
  userId: string | undefined
): { data: PagePictureData | null; isLoading: boolean } {
  const query = useQuery({
    queryKey: ["cached-page-picture", pageId, userId],
    queryFn: async (): Promise<PagePictureData | null> => {
      if (!pageId || !userId) return null;

      const { data, error } = await supabase
        .from("meta_cached_facebook_pages")
        .select("page_id, page_name, picture_url, picture_is_silhouette")
        .eq("page_id", pageId)
        .eq("user_id", userId)
        .limit(1);

      if (error || !data || data.length === 0) return null;
      const row = data[0];

      return {
        pageId: row.page_id,
        pageName: row.page_name || "",
        pictureUrl: row.picture_url || null,
        isSilhouette: row.picture_is_silhouette ?? false,
      };
    },
    enabled: !!pageId && !!userId,
    staleTime: 10 * 60 * 1000,
  });

  return { data: query.data ?? null, isLoading: query.isLoading };
}
